import React, { useState, useEffect } from 'react';
import api from '../../api';
import { 
  FaLeaf, FaCheckCircle, FaSave, FaTrash, FaEdit, FaPlus, FaTimes, 
  FaUserTie, FaCertificate, FaMapMarkerAlt, FaThermometerHalf, FaTools, FaChartLine 
} from 'react-icons/fa';
import styles from './Admin.module.css'; // Shared CSS

const AdminBenefits = () => {
  const [activeTab, setActiveTab] = useState('benefits'); // 'benefits' or 'impact'
  const [benefits, setBenefits] = useState([]);
  const [impactStats, setImpactStats] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '' });

 

  // --- FORM STATES ---
  // Benefits Form
  const [benefitForm, setBenefitForm] = useState({
    id: 0, iconName: 'FaCheckCircle', title: '', description: ''
  });

  // Impact Form
  const [impactForm, setImpactForm] = useState({
    id: 0, iconEmoji: '⚡', value: '', unit: '', label: '', description: '', colorHex: '#FFD700'
  });

  // Icon Options for Dropdown
  const iconOptions = [
    "FaUserTie", "FaCertificate", "FaMapMarkerAlt", "FaThermometerHalf", 
    "FaTools", "FaChartLine", "FaCheckCircle", "FaLeaf"
  ];

  // --- 1. FETCH DATA ---
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
    const [benRes, impRes] = await Promise.all([
  api.get('/Benefits/list'),
  api.get('/Benefits/impact')
]);
      setBenefits(benRes.data);
      setImpactStats(impRes.data);
    } catch (err) {
      console.error("Error fetching data", err);
    }
  };

  // --- 2. BENEFIT ACTIONS ---
  const handleBenefitChange = (e) => {
    setBenefitForm({ ...benefitForm, [e.target.name]: e.target.value });
  };

  const saveBenefit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
     await api.post('/Benefits/save-benefit', benefitForm, {
  headers: { Authorization: `Bearer ${token}` }
});
      setMessage({ text: "Benefit Saved!", type: "success" });
      fetchData();
      resetBenefitForm();
    } catch (err) {
      setMessage({ text: "Error saving benefit", type: "error" });
    } finally {
      setLoading(false);
    }
  };

  const deleteBenefit = async (id) => {
    if (!window.confirm("Delete this benefit?")) return;
    try {
      const token = localStorage.getItem('token');
     await api.delete(`/Benefits/delete-benefit/${id}`, {
  headers: { Authorization: `Bearer ${token}` }
});
      fetchData();
    } catch (err) {
      alert("Error deleting");
    }
  };

  const editBenefit = (item) => {
    setBenefitForm(item);
    window.scrollTo(0, 0); // Scroll to form
  };

  const resetBenefitForm = () => {
    setBenefitForm({ id: 0, iconName: 'FaCheckCircle', title: '', description: '' });
  };

  // --- 3. IMPACT ACTIONS ---
  const handleImpactChange = (e) => {
    setImpactForm({ ...impactForm, [e.target.name]: e.target.value });
  };

  const saveImpact = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
     await api.post('/Benefits/save-impact', impactForm, {
  headers: { Authorization: `Bearer ${token}` }
});
      setMessage({ text: "Stat Saved!", type: "success" });
      fetchData();
      resetImpactForm();
    } catch (err) {
      setMessage({ text: "Error saving stat", type: "error" });
    } finally {
      setLoading(false);
    }
  };

  const deleteImpact = async (id) => {
    if (!window.confirm("Delete this stat?")) return;
    try {
      const token = localStorage.getItem('token');
     await api.delete(`/Benefits/delete-impact/${id}`, {
  headers: { Authorization: `Bearer ${token}` }
});
      fetchData();
    } catch (err) {
      alert("Error deleting");
    }
  };

  const editImpact = (item) => {
    setImpactForm(item);
    window.scrollTo(0, 0);
  };

  const resetImpactForm = () => {
    setImpactForm({ id: 0, iconEmoji: '⚡', value: '', unit: '', label: '', description: '', colorHex: '#FFD700' });
  };

  return (
    <div>
      <div className={styles.formCard} style={{ maxWidth: '1100px' }}>
        
        <h3 style={{ marginBottom: '1.5rem', color: '#4ade80', display: 'flex', alignItems: 'center', gap: '10px' }}>
          <FaLeaf /> Benefits & Impact
        </h3>

        {/* TABS */}
        <div style={{ display: 'flex', gap: '10px', marginBottom: '25px', borderBottom: '1px solid rgba(255,255,255,0.1)', paddingBottom: '10px' }}>
          <button 
            onClick={() => setActiveTab('benefits')}
            style={{
              background: activeTab === 'benefits' ? '#4ade80' : 'transparent',
              color: activeTab === 'benefits' ? '#0f2027' : '#94a3b8',
              border: 'none', padding: '10px 20px', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold'
            }}
          >
            Why Choose Us
          </button>
          <button 
            onClick={() => setActiveTab('impact')}
            style={{
              background: activeTab === 'impact' ? '#4ade80' : 'transparent',
              color: activeTab === 'impact' ? '#0f2027' : '#94a3b8',
              border: 'none', padding: '10px 20px', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold'
            }}
          >
            Environmental Impact
          </button>
        </div>

        {/* Message Alert */}
        {message.text && (
          <div style={{
            padding: '10px', marginBottom: '20px', borderRadius: '5px',
            background: message.type === 'error' ? 'rgba(239,68,68,0.2)' : 'rgba(74,222,128,0.2)',
            color: message.type === 'error' ? '#fca5a5' : '#4ade80'
          }}>
            {message.text}
          </div>
        )}

        {/* ==================================
            TAB 1: BENEFITS (Why Choose Us)
           ================================== */}
        {activeTab === 'benefits' && (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '30px' }}>
            
            {/* Form Side */}
            <div>
              <h4 style={{ color: '#fff', marginBottom: '15px', borderBottom: '1px solid #333', paddingBottom: '5px' }}>
                {benefitForm.id === 0 ? 'Add New Benefit' : 'Edit Benefit'}
              </h4>
              <form onSubmit={saveBenefit}>
                <div className={styles.formGroup}>
                  <label>Title</label>
                  <input type="text" name="title" value={benefitForm.title} onChange={handleBenefitChange} className={styles.formInput} required />
                </div>
                <div className={styles.formGroup}>
                  <label>Select Icon</label>
                  <select name="iconName" value={benefitForm.iconName} onChange={handleBenefitChange} className={styles.formInput}>
                    {iconOptions.map(icon => <option key={icon} value={icon}>{icon}</option>)}
                  </select>
                </div>
                <div className={styles.formGroup}>
                  <label>Description</label>
                  <textarea name="description" value={benefitForm.description} onChange={handleBenefitChange} className={styles.formInput} rows="3" required />
                </div>
                
                <div style={{display:'flex', gap:'10px'}}>
                  <button type="submit" className={styles.primaryBtn} disabled={loading}>
                    {loading ? 'Saving...' : <><FaSave /> {benefitForm.id === 0 ? 'Add' : 'Update'}</>}
                  </button>
                  {benefitForm.id !== 0 && (
                    <button type="button" onClick={resetBenefitForm} style={{background:'#64748b', border:'none', color:'white', padding:'10px', borderRadius:'8px', cursor:'pointer'}}>
                      <FaTimes /> Cancel
                    </button>
                  )}
                </div>
              </form>
            </div>

            {/* List Side */}
            <div>
              <h4 style={{ color: '#fff', marginBottom: '15px' }}>Current List ({benefits.length})</h4>
              <div style={{ maxHeight: '500px', overflowY: 'auto' }}>
                {benefits.map(item => (
                  <div key={item.id} style={{ background: 'rgba(255,255,255,0.05)', padding: '15px', borderRadius: '8px', marginBottom: '10px', borderLeft: '4px solid #00D084' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <h5 style={{ margin: '0', color: 'white' }}>{item.title}</h5>
                      <div style={{display:'flex', gap:'5px'}}>
                        <button onClick={() => editBenefit(item)} style={{background:'transparent', border:'none', color:'#4ade80', cursor:'pointer'}}><FaEdit /></button>
                        <button onClick={() => deleteBenefit(item.id)} style={{background:'transparent', border:'none', color:'#ef4444', cursor:'pointer'}}><FaTrash /></button>
                      </div>
                    </div>
                    <small style={{ color: '#94a3b8' }}>Icon: {item.iconName}</small>
                    <p style={{ margin: '5px 0 0', fontSize: '0.85rem', color: '#cbd5e1' }}>{item.description}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* ==================================
            TAB 2: IMPACT STATS
           ================================== */}
        {activeTab === 'impact' && (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '30px' }}>
            
            {/* Form Side */}
            <div>
              <h4 style={{ color: '#fff', marginBottom: '15px', borderBottom: '1px solid #333', paddingBottom: '5px' }}>
                {impactForm.id === 0 ? 'Add Impact Stat' : 'Edit Stat'}
              </h4>
              <form onSubmit={saveImpact}>
                <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:'15px'}}>
                  <div className={styles.formGroup}>
                    <label>Label (e.g. Trees)</label>
                    <input type="text" name="label" value={impactForm.label} onChange={handleImpactChange} className={styles.formInput} required />
                  </div>
                  <div className={styles.formGroup}>
                    <label>Value (e.g. 120)</label>
                    <input type="text" name="value" value={impactForm.value} onChange={handleImpactChange} className={styles.formInput} required />
                  </div>
                </div>

                <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:'15px'}}>
                  <div className={styles.formGroup}>
                    <label>Unit (e.g. kWh)</label>
                    <input type="text" name="unit" value={impactForm.unit} onChange={handleImpactChange} className={styles.formInput} required />
                  </div>
                  <div className={styles.formGroup}>
                    <label>Emoji Icon (e.g. ⚡)</label>
                    <input type="text" name="iconEmoji" value={impactForm.iconEmoji} onChange={handleImpactChange} className={styles.formInput} />
                  </div>
                </div>

                <div className={styles.formGroup}>
                  <label>Card Color</label>
                  <div style={{display:'flex', alignItems:'center', gap:'10px'}}>
                    <input type="color" name="colorHex" value={impactForm.colorHex} onChange={handleImpactChange} style={{height:'40px', width:'50px', border:'none', background:'none', cursor:'pointer'}} />
                    <span style={{color:'white'}}>{impactForm.colorHex}</span>
                  </div>
                </div>

                <div className={styles.formGroup}>
                  <label>Description</label>
                  <textarea name="description" value={impactForm.description} onChange={handleImpactChange} className={styles.formInput} rows="2" />
                </div>

                <div style={{display:'flex', gap:'10px'}}>
                  <button type="submit" className={styles.primaryBtn} disabled={loading}>
                    {loading ? 'Saving...' : <><FaSave /> {impactForm.id === 0 ? 'Add' : 'Update'}</>}
                  </button>
                  {impactForm.id !== 0 && (
                    <button type="button" onClick={resetImpactForm} style={{background:'#64748b', border:'none', color:'white', padding:'10px', borderRadius:'8px', cursor:'pointer'}}>
                      <FaTimes /> Cancel
                    </button>
                  )}
                </div>
              </form>
            </div>

            {/* List Side */}
            <div>
              <h4 style={{ color: '#fff', marginBottom: '15px' }}>Current Stats ({impactStats.length})</h4>
              <div style={{ maxHeight: '500px', overflowY: 'auto' }}>
                {impactStats.map(item => (
                  <div key={item.id} style={{ background: 'rgba(255,255,255,0.05)', padding: '15px', borderRadius: '8px', marginBottom: '10px', borderLeft: `4px solid ${item.colorHex}` }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <h5 style={{ margin: '0', color: 'white', display:'flex', alignItems:'center', gap:'8px' }}>
                        <span style={{fontSize:'1.2rem'}}>{item.iconEmoji}</span> {item.label}
                      </h5>
                      <div style={{display:'flex', gap:'5px'}}>
                        <button onClick={() => editImpact(item)} style={{background:'transparent', border:'none', color:'#4ade80', cursor:'pointer'}}><FaEdit /></button>
                        <button onClick={() => deleteImpact(item.id)} style={{background:'transparent', border:'none', color:'#ef4444', cursor:'pointer'}}><FaTrash /></button>
                      </div>
                    </div>
                    <h3 style={{color: item.colorHex, margin:'5px 0 0'}}>{item.value} <span style={{fontSize:'0.9rem', color:'#94a3b8'}}>{item.unit}</span></h3>
                    <p style={{ margin: '5px 0 0', fontSize: '0.85rem', color: '#cbd5e1' }}>{item.description}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default AdminBenefits;